import React, { FC } from 'react'

import classes from './ChannelBadge.module.scss'
import { ChannelIcon } from './ChannelIcon'

type ChannelBadgeProps = {
  channelName: string
}

export const ChannelBadge: FC<ChannelBadgeProps> = ({ channelName }) => {
  return (
    <div className={classes.Container}>
      <ChannelIcon />
      <span>{channelName}</span>
    </div>
  )
}
